module.exports = __webpack_public_path__ + "76b253366d6ff4d313da752984994fd9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/bandana.png
// module id = 1801
// module chunks = 0